import {decimalsCount, decimalsMultiplier} from '#/utils/contract-consts';
import {roundDecimals} from '#/utils/math-utils';

export const tokenAmountToInputString = (
  numberToFormat: number | undefined,
  decimals: number = decimalsCount,
  decimalsIfInteger = true,
): string => {
  if (typeof numberToFormat !== 'number' || numberToFormat === 0) return '';

  const divided = roundDecimals(numberToFormat / decimalsMultiplier, decimals);

  if (!decimalsIfInteger && Number.isInteger(divided)) {
    return divided.toString();
  }

  return divided.toFixed(decimals);
};

export const stringToTokenAmount = (stringToConvert: string | undefined): number => {
  const floatValue = parseFloat(stringToConvert?.replace(',', '') ?? '');

  if (isNaN(floatValue)) return 0;

  return Math.round(floatValue * decimalsMultiplier);
};
